import Repository from './Repository.js'

import querystring from 'querystring'

export default {
    get(access_token, id_account) {
        return Repository.get(`?action=get&id_account=${id_account}`, {
            headers: {'Authorization': access_token}
        })
    },
    getCache(access_token) {
        return Repository.get(`?action=getCache`, {
            headers: {'Authorization': access_token}
        })
    },
    addCredentials(access_token, loginname, password, sites, company, active) {
        const data = querystring.stringify({
            "loginname": loginname,
            "password": password,
            "sites": sites,
            "company": company,
            "active": active
        });
        return Repository.post(`?action=addCredentials`, data, {
            headers: {'Authorization': access_token}
        });
    },
    editCredentials(access_token, id_account, update_data) {
        if (!update_data) {
            return
        }

        let params = {
            "id_account": id_account
        }

        if ('loginname' in update_data) { params['loginname'] = update_data['loginname'] }
        if ('password' in update_data) { params['password'] = update_data['password'] }
        if ('company' in update_data) { params['company'] = update_data['company'] }
        if ('active' in update_data) { params['active'] = update_data['active'] }

        let data = querystring.stringify(params)

        return Repository.post(`?action=editCredentials`, data, {
            headers: {'Authorization': access_token}
        })
    },
    getFromSite(access_token, id_site) {
        return Repository.get(`?action=getFromSite&id_site=${id_site}`, {
            headers: {'Authorization': access_token}
        })
    },
    getArticles(access_token, id_site, page) {
        return Repository.get(`?action=getArticles&id_site=${id_site}&page=${page}`, {
            headers: {'Authorization': access_token}
        })
    },
    getLogs(access_token, id_site, page) {
        return Repository.get(`?action=getLogs&id_site=${id_site}&page=${page}`, {
            headers: {'Authorization': access_token}
        })
    },
    getFromCompany(access_token, id_customer) {
        return Repository.get(`?action=getFromCompany&id_customer=${id_customer}`, {
            headers: {'Authorization': access_token}
        })
    },
    getAll(access_token, page, sort, sortDir, filters) {
        let params = {
            page: page
        }

        if (sort) {
            params['sort'] = sort

            if (sortDir) {
                params['sort_dir'] = sortDir
            }
        }

        if (filters) {
            if ('logEvents' in filters && filters['logEvents'].length) {
                params['log_events'] = filters['logEvents'].join(',')
            }
            if ('status' in filters && filters['status'] != -1) {
                params['status'] = filters['status']
            }
            if ('search' in filters && filters['search']) {
                if (filters['search'].trim().length !== 0) {
                    params['search'] = filters['search']
                }
            }
            if ('date' in filters && 'min' in filters['date'] && filters['date']['min']) {
                params['dateMin'] = filters['date']['min']
            }
            if ('date' in filters && 'max' in filters['date'] && filters['date']['max']) {
                params['dateMax'] = filters['date']['max']
            }

            if ('successfulAttempts' in filters && filters['successfulAttempts']) {
                params['successfulAttempts'] = filters['successfulAttempts']
            }
            if ('failedAttempts' in filters && filters['failedAttempts']) {
                params['failedAttempts'] = filters['failedAttempts']
            }
        }

        let query = querystring.stringify(params)

        return Repository.get(`?action=getAll&${query}`, {
            headers: {'Authorization': access_token}
        })
    },
    getLogEvents(access_token) {
        return Repository.get(`?action=getEvents`, {
            headers: {'Authorization': access_token}
        })
    }
}
